/** PURE_IMPORTS_START .._.._Observable,.._.._observable_throw PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { _throw } from '../../observable/throw';
Observable.throw = _throw;
//# sourceMappingURL=throw.js.map 



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/rxjs/_esm5/add/observable/throw.js
// module id = ../../../../rxjs/_esm5/add/observable/throw.js
// module chunks = vendor